import {Modal} from 'react-bootstrap';
import React, { useContext, useState } from 'react';
import { SketchPicker } from 'react-color';
import Slider from 'rc-slider';
import { UserContext } from '../../Contexts/UserContext';
import { Permission } from '../../Utils/Permission';
import { hasPermission } from '../../Utils/PermissionUtils';
import toast from 'react-hot-toast';

const ManageGeoJsonModal = (props) => {
    const { user, selectedOrgId } = useContext(UserContext);

    const [geoJson, setGeoJson] = useState(props.geoJson ?? {
        name: '',
        strokeColor: '#ffffff',
        strokeWeight: 4,
        fillColor: '#ffffff',
        fillOpacity: 0
    });

    const updateGeoJson = (obj) => {
        console.log(obj);
        setGeoJson((s) => ({...s, ...obj}));
    };

    const save = () => {
        if(geoJson.name == "")
        {
            toast.error("Please enter a valid name for GeoJson Type");
            return;
        }
        props.save(geoJson);
    };

    return (
        <>
            <Modal
                show={() => props.setShowModal(true)}
                onHide={() => props.setShowModal(false)}
                backdrop="static"
                keyboard={false}
                dialogClassName="modal-dialog"
                className="delete-confirm-modal"
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        <h5>GeoJson Type</h5>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row">
                        <div className="col-md-6">
                            <div className="form-group">
                                <label className="form-label" htmlFor="name">GeoJson Name <span className="required">*</span></label>
                                {
                                    hasPermission(user, Permission.GeoJsonTypeNameUpdate, selectedOrgId)
                                    ? <input type="text" className="form-control" id="name" name="name" value={geoJson.name} onChange={(e) => updateGeoJson({name: e.target.value})}/>
                                    : <span>{geoJson.name}</span>
                                }
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="form-group">
                                <div className="settings-color-block">
                                    <div>Stroke Color</div>
                                    <SketchPicker color={geoJson.strokeColor} onChangeComplete={(color) => updateGeoJson({strokeColor: color.hex})} />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-12">
                            <div className="form-group">
                                <div className="toggle-switch" key="defaultZoomlevel">
                                    <span className="label">Stroke Weight</span>
                                    <Slider min={1}
                                        max={20}
                                        step={1}
                                        count={1}
                                        defaultValue={geoJson.strokeWeight}
                                        key={geoJson.strokeWeight}
                                        pushable
                                        marks={{[1]:[1], [geoJson.strokeWeight]: [geoJson.strokeWeight], [20]:[20]}}
                                        onChangeComplete={(e) => updateGeoJson({strokeWeight: e})}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div>
                        &nbsp;
                    </div>

                    <div className="row">
                        <div className="col-md-12">
                            <div className="form-group">
                                <div className="settings-color-block">
                                    <div>Fill Color</div>
                                    <SketchPicker color={geoJson.fillColor} onChangeComplete={(color) => updateGeoJson({fillColor: color.hex})} />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-12">
                            <div className="form-group">
                                <div className="toggle-switch" key="defaultZoomlevel">
                                    <span className="label">Fill Opacity</span>
                                    <Slider min={0}
                                        max={20}
                                        step={1}
                                        count={1}
                                        defaultValue={geoJson.fillOpacity*20}
                                        key={geoJson.fillOpacity}
                                        pushable
                                        marks={{[0]:[0], [geoJson.fillOpacity*20]: [geoJson.fillOpacity], [20]:[1]}}
                                        onChangeComplete={(e) => updateGeoJson({fillOpacity: e/20})}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                </Modal.Body>
                <Modal.Footer>
                    <button type="button" className="btn btn-outline" data-bs-dismiss="modal" aria-label="Close" onClick={() => props.setShowModal(false)}>CANCEL</button>
                    <button type="button" className="btn btn-danger" onClick={save}>SAVE</button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default ManageGeoJsonModal;